export const partnerStatus = [
  { value: '1', text: 'Bronze' },
  { value: '2', text: 'Silver' },
  { value: '3', text: 'Gold' },
  { value: '4', text: 'Royal' },
]

export const partnerStatusMap = {
  bronze: (): string => 'bronze',
  silver: () => 'silver',
  gold: () => 'gold',
  royal: () => 'royal',
}

export const partnerStatusHumanToNumber = function (status: string) {
  switch (status) {
    case partnerStatusMap.bronze():
      return '1'
    case partnerStatusMap.silver():
      return '2'
    case partnerStatusMap.gold():
      return '3'
    case partnerStatusMap.royal():
      return '4'
  }
}
